/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNoKnownAllergies = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="m22.707 21.293-1.414 1.414-2.969-2.969A9.945 9.945 0 0 1 12 22C6.477 22 2 17.523 2 12a9.95 9.95 0 0 1 2.26-6.326L1.293 2.707l1.414-1.414zM5.681 7.095A8 8 0 0 0 12 20c1.848 0 3.548-.63 4.902-1.683l-3-3c-.266.22-.571.39-.903.508V17h-2v-1.175a2.991 2.991 0 0 1-.904-.508l-.924.925-1.414-1.414 1.29-1.29A3.018 3.018 0 0 1 9 13H7v-2h2c0-.184.016-.363.048-.538zM11 13a1 1 0 0 0 1.468.882L11 12.414zm1-11c5.523 0 10 4.477 10 10a9.954 9.954 0 0 1-1.248 4.838l-1.488-1.488A8 8 0 0 0 8.65 4.736l-1.49-1.49A9.954 9.954 0 0 1 12 2z" />
        <path d="M13 8.174c.332.117.637.289.903.508l.925-.924 1.414 1.414-1.29 1.29c.03.175.048.354.048.538h2v2h-.086L11 7.086V7h2z" />
      </g>
    </g>
  </Icon>
);
export { SvgNoKnownAllergies as NoKnownAllergies };
